import React, { PureComponent } from 'react';
import styled from 'styled-components';
import bindMethods from 'auto-bind';

import PropTypes from 'prop-types';
import MediaContent from './MediaContent';
import OperationArea from './OperationArea';
import AssetInfo from './AssetInfo';
import WarningDialog from './components/WarningDialog';

import { Colors } from '../../constants';

export const AssetDetailsPanel = styled.div`
  flex-basis: min-content;
  flex-wrap: nowrap;
  min-width: 372px;
  -webkit-flex-direction: column;
   flex-direction: column;
   -webkit-justify-content: flex-start;
   justify-content: flex-start;
  flex-grow: 1;
  overflow: auto;
  background-color: ${Colors.PAPER};
`;

export const AssetDetailsContainer = styled.div`
  flex-wrap: nowrap;
  display: flex;
  flex-direction: column;
`;

export const MultiSelectText = styled.div`
  color: ${Colors.BLACK_100};
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export default class AssetDetails extends PureComponent {
  static defaultProps = {
    selectedAssetsCount: 0,
  };

  constructor(props) {
    super(props);
    bindMethods(this);
  }

  render() {
    const { selectedAssetsCount } = this.props;

    return (
      <AssetDetailsPanel>
        {selectedAssetsCount > 1 ? (
          <MultiSelectText>{`${selectedAssetsCount} Assets Selected`}</MultiSelectText>
        ) : (
          <AssetDetailsContainer id="AssetDetails" className="AssetDetails">
            <MediaContent />
            <OperationArea />
            <AssetInfo />
          </AssetDetailsContainer>
        )}
        <WarningDialog />
      </AssetDetailsPanel>
    );
  }
}

AssetDetails.propTypes = {
  selectedAssetsCount: PropTypes.number,
};
